import React, { useState } from 'react';
import EasyRoadMap from '../../EasyRoadMap';
import Label from '../../Label';
import FieldItem from './FieldItem';
import { Tooltip } from 'antd';
import {
  StopTravelStatus,
  SystemState,
  VehicleScheduleState,
} from '@/redux/type';
import './board.scss';
import {
  enumTranslator,
  formatTimetoString,
  getPermissionById,
  translatorVendingScheduleState,
} from '@/utils';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import { PermissionButton } from '@/utils/constant';
import Timer from '../../RoadStation/components/time';
import VehicleInitialDetail from '../../VehicleInitialDetail';
import { convertSpeedMsToKmh } from '@/utils/util';
import { Method } from '@/fetch/core/util';

type BoardItemProp = {
  data: any;
  handleClickStopItem: AnyFunc;
  handleScheduleModel: AnyFunc;
};

const BoardItem = (props: BoardItemProp) => {
  const {
    name,
    systemState,
    alarmEvent,
    id,
    stopList,
    power,
    speed,
    stationName,
    vehicleState,
    totalOrderNum,
    finishedOrderNum,
    mileage,
    mileageTotal,
    scheduleState,
    vehicleBusinessType,
    taskType,
  } = props.data;
  const [totalTraveledMileage, setTotalTraveledMileage] = useState<any>(0);
  const _InitInfoBtnPermission = getPermissionById(
    PermissionButton.VEHICLE_INIT_PREVIEW_BTN,
  );
  let cls = '';
  let text = '';
  if (systemState === 'CONNECTION_LOST') {
    cls = 'connection_lost';
    text = SystemState.CONNECTION_LOST;
  } else if (systemState === 'OFFLINE') {
    cls = 'offline';
    text = SystemState.OFFLINE;
  } else {
    // 有报警事件都叫异常
    if (['NORMAL', 'SELF_REPAIR', 'MALFUNCTION'].includes(systemState)) {
      cls = 'normal';
      text = SystemState.NORMAL;
    }
    if (alarmEvent.length > 0) {
      cls = 'waring';
      text = '异常';
    }
  }
  const handleStopClick = (id: number, stopAction: string, e: any) => {
    e.stopPropagation();
    const controlPermission = getPermissionById(
      PermissionButton.SPV_ORDER_DETAIL,
    );
    if (!controlPermission) {
      return;
    }
    props.handleClickStopItem &&
      props.handleClickStopItem({
        id,
        stopAction,
        name,
        scheduleState,
        stopList,
      });
  };

  const onVisibleChange = (visible: boolean) => {
    if (visible) {
      request({
        path: '/monitor/web/realtime/mileage/finished',
        method: Method.POST,
        body: {
          vehicleName: name,
        },
      }).then((res: HTTPResponse) => {
        if (res.code === HttpStatusCode.Success) {
          setTotalTraveledMileage(
            (res.data && (res.data / 1000).toFixed(2)) || 0,
          );
        }
      });
    }
  };

  const stayingStop = stopList.find(
    (item: StopItem) => item.travelStatus === StopTravelStatus.STAY,
  );
  const stayingStopIndex = stopList.findIndex(
    (item: StopItem) => item.travelStatus === StopTravelStatus.STAY,
  );
  const formatMillageInfo = () => {
    const currentStop = stopList.find((item: any) => {
      return item.travelStatus === 'START';
    });
    const totalTime =
      new Date().getTime() - new Date(currentStop?.startTime).getTime();
    return {
      time: formatTimetoString(totalTime) || '--',
      name: currentStop?.name || '--',
    };
  };

  const scheduleLabel =
    vehicleBusinessType === 'VENDING'
      ? translatorVendingScheduleState(scheduleState)
      : taskType === 'DROPOFF' && scheduleState === 'DELIVERY'
        ? VehicleScheduleState.DELIVERY
        : taskType === 'DROPOFF' && scheduleState === 'ALREADY'
          ? VehicleScheduleState.ALREADY
          : enumTranslator('SCHEDULE_STATE_ENUM', scheduleState);
  return (
    <>
      <li
        className='board-item'
        onClick={(e: any) => {
          const url = '/app/single?license=' + name;
          window.open(url, '_blank');
        }}
      >
        <div className='top-head'>
          <div className='head-left'>
            <span className='font-JDZhengHT title'>{name}</span>
            <span className='sub-title'>{stationName}</span>
            <i className={`vehicle-icon ${cls} ${vehicleBusinessType}`}></i>
          </div>
          <div className={`head-right ${cls}`}>{text}</div>
        </div>
        <div className='alarm-event-container'>
          {alarmEvent.map((item: any, index: number) => (
            <Label
              text={enumTranslator('ALARM_EVENT_ENUM', item.alarmEvent)}
              timeStamp={item.reportTime}
              key={index}
            />
          ))}
        </div>
        <div className='easy-roadmap'>
          <EasyRoadMap
            key={id + name}
            stopList={stopList}
            vehicleId={id}
            vehicleName={name}
            scheduleState={scheduleState}
            handleStopClick={handleStopClick}
            handleScheduleModel={() => {
              props.handleScheduleModel();
            }}
          />

          {['SETOUT', 'RETURN'].includes(scheduleState) && (
            <span className='going-laber' style={{ left: '30%' }}>
              已行驶{formatMillageInfo().time} | {formatMillageInfo().name}
            </span>
          )}
          {stayingStop &&
            stayingStopIndex > 0 &&
            stayingStopIndex < stopList.length - 1 && (
              <span className='timer-label'>
                <Timer
                  time={stayingStop.time}
                  status={stayingStop.travelStatus}
                  waitingTime={stayingStop.waitingTime}
                  arrivedTime={stayingStop.arrivedTime}
                  estDepartTime={stayingStop.estDepartTime}
                />
                | {stayingStop.name}
              </span>
            )}
        </div>
        <div className='status-fields'>
          <FieldItem
            iconName='speed'
            label={convertSpeedMsToKmh(speed, 1, systemState)}
          />
          <FieldItem iconName='status' label={scheduleLabel} />
          <FieldItem iconName='power' label={power ? power + ' %' : '--'} />
          <span className='field-item'>
            <i className='vehicleState'></i>
            <span>
              {enumTranslator('VEHICLE_STATE_ENUM', vehicleState) || '--'}
            </span>
            <span
              onClick={(e: any) => {
                e.stopPropagation();
              }}
            >
              {vehicleState === 'INITIALIZATION' && _InitInfoBtnPermission && (
                <VehicleInitialDetail vehicleName={name} />
              )}
            </span>
          </span>
          <span className='field-item'>
            <i className='mileage'></i>
            <Tooltip
              title={`整段已走里程 ${totalTraveledMileage} KM`}
              onOpenChange={onVisibleChange}
            >
              <span>{`${mileage}/${mileageTotal} km`}</span>
            </Tooltip>
          </span>
          {vehicleBusinessType != 'VENDING' && (
            <FieldItem
              iconName='order'
              label={`${finishedOrderNum}/${totalOrderNum} 单`}
            />
          )}
        </div>
      </li>
    </>
  );
};

export default React.memo(BoardItem);
